/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';
import { debounce } from '../../api/apiUtils';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import {
  DATE_MONTH_YEAR_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';
import { cancelTboInsuranceApi } from '../../api/tboInsuranceApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';

function InsuranceBookingsList({ insuranceBookings }) {
  const [transactionsList, setTransactionsList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);

  useEffect(() => {
    setTransactionsList(insuranceBookings);
  }, [insuranceBookings]);

  const setSearchResults = debounce((val) => {
    if (insuranceBookings.length > 0) {
      let data = [...insuranceBookings];
      if (val !== '') {
        data = data.filter((o) =>
          Object.keys(o).some(
            (k) =>
              o[k] !== null &&
              o[k] !== undefined &&
              o[k].toString().toLowerCase().includes(val.toLowerCase()),
          ),
        );
      }
      setTransactionsList(data);
    }
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  //   const getFlightTicket = (txid) => {
  //     let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
  //     route = route.replace(':transactionId', txid);
  //     return route;
  //   };
  //   const getFlightOrderDetails = (txid) => {
  //     let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_ORDER_DETAILS;
  //     route = route.replace(':transactionId', txid);
  //     return route;
  //   };
  const getReceipt = (txid) => {
    let route = NAVIGATION_ROUTES.INSUARNCE_VOUCHER;
    route = route.replace(':transactionId', txid);
    return route;
  };
  // const getInvoice = (txid) => {
  //   let route = NAVIGATION_ROUTES.INSUARNCE_INVOICE;
  //   route = route.replace(':transactionId', txid);
  //   return route;
  // };

  const canceltboinsurance = async (txid) => {
    try {
      setIsLoading(true);
      const res = await cancelTboInsuranceApi(txid);
      const status = res?.ApiStatus?.Status || res?.Root?.Status;
      const message = res?.ApiStatus?.Message || res?.Root?.Message;
      if (res && status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Success',
          description: message || 'Insurance policy cancelled successfully',
        });
        setTransactionsList((prevList) =>
          prevList.map((item) =>
            item.Txid === txid ? { ...item, BookingStatus: 'Cancelled' } : item,
          ),
        );
      } else {
        setAlert({
          variant: 'error',
          title: 'Error',
          description: message || 'Failed to cancel insurance policy',
        });
      }
    } catch (err) {
      setAlert({
        variant: 'error',
        title: 'Error',
        description: 'Something went wrong. Please try again later.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="flight-canx-list p-2 ">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <div className="flight-canx-list_container ms-1">
        <div className="m-3 d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Txid</th>
              <th>TxDate</th>
              <th>Insurance Name</th>
              <th>Insurance Details</th>
              <th>AgentId</th>
              <th>Inv.Amount</th>
              <th>Remarks</th>
              <th>SupplierId</th>
              <th>Booking Status</th>
              <th>Invoice Number</th>
              <th>Receipt</th>
              <th>Cancellation</th>
            </tr>
          </thead>
          <tbody>
            {transactionsList.map((transaction, index) => (
              <tr key={index}>
                <td>{transaction.Txid}</td>
                <td>
                  {formatDate(
                    getNewDate(transaction?.TxDate?.split(' ')[0]),
                    DATE_MONTH_YEAR_FORMAT,
                  )}
                </td>
                <td>{transaction.InsuranceName}</td>
                <td>{transaction.PolicyNumber}</td>
                <td>{transaction.AgentId}</td>
                <td>{transaction.TotalInvoice.toFixed(1)}</td>
                <td>{transaction.Remarks}</td>
                <td>{transaction.SupplierId}</td>
                <td>{transaction.BookingStatus}</td>
                <td>{transaction.InvoiceNumber}</td>
                <td>
                  <AppLink
                    linkText="Receipt"
                    isLink
                    href={getReceipt(transaction.Txid)}
                    target="_blank"
                  />
                  <br />
                  {/* <AppLink
                    linkText="Invoice"
                    isLink
                    href={getInvoice(transaction.Txid)}
                    target="_blank"
                  /> */}
                </td>
                <td>
                  <AppLink
                    linkText="Cancel"
                    onClick={() => canceltboinsurance(transaction.Txid)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
InsuranceBookingsList.propTypes = {
  insuranceBookings: PropTypes.array.isRequired,
};

export default InsuranceBookingsList;
